import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { useContext } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import { SoundContext } from './SoundProvider'
import { WID } from '../../constants/Language'
import { List, ListItem, ListItemSecondaryAction, ListItemText, Switch } from '@material-ui/core'
import { Word } from '../../containers'

const styles = theme => ({
  dialog: {
  }
})

const SoundSettingsDialog = (props) => {

  const {open, setOpen, enableEnterSE, enablePutPieceSE, enableSwapSE, setEnableEnterSE, setEnablePutPieceSE, setEnableSwapSE} = useContext(SoundContext)

  const handleClickClose = () => {
    setOpen(false)
  }

  const listItemProps = [
    {
      wid: WID.SOUND_SETTINGS_DIALOG.ENTER,
      checked: enableEnterSE,
      onChange: () => {
        setEnableEnterSE(!enableEnterSE)
      },
      color: "primary"
    },
    {
      wid: WID.SOUND_SETTINGS_DIALOG.PUT_PIECE,
      checked: enablePutPieceSE,
      onChange: () => {
        setEnablePutPieceSE(!enablePutPieceSE)
      },
      color: "primary"
    },
    {
      wid: WID.SOUND_SETTINGS_DIALOG.SWAP,
      checked: enableSwapSE,
      onChange: () => {
        setEnableSwapSE(!enableSwapSE)
      },
      color: "primary"
    }
  ]

  return (
    <Dialog open={open} onClose={handleClickClose} fullWidth>
      <DialogTitle>効果音設定</DialogTitle>
      <DialogContent>
        <List>
          {listItemProps.map((itemProps, index) => {
            return (
              <ListItem key={index}>
                <ListItemText><Word wid={itemProps.wid}/></ListItemText>
                <ListItemSecondaryAction>
                  <Switch
                    checked={itemProps.checked}
                    onChange={itemProps.onChange}
                    color={itemProps.color}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            )
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClickClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles, { withTheme: true })(SoundSettingsDialog)



// WEBPACK FOOTER //
// ./src/Parts/Sound/SoundSettingsDialog.js